import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5923addc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Carousel from 'primevue/carousel';
import FairLaunchBanner from '@/components/FairLaunchBanner.vue';
import TradingCompetitionBanner from '@/components/TradingCompetitionBanner.vue';
import LiquidityCompetitionBanner from '@/components/LiquidityCompetitionBanner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BannersCarousel',
  setup(__props) {

const { state } = useStore();
const banners = computed(() => {
  return [
    { name: 'FairLaunch', component: () => FairLaunchBanner, isShow: true },
    { name: 'TradingCompetition', component: () => TradingCompetitionBanner, isShow: true },
    { name: 'LiquidityCompetition', component: () => LiquidityCompetitionBanner, isShow: true },
  ];
});
const bannersForShow = computed(() => banners.value.filter(item => item.isShow));

onMounted(() => {
  const buttonPrev = document.querySelector('.p-carousel-prev');
  const buttonNext = document.querySelector('.p-carousel-next');
  if (buttonPrev && buttonNext) buttonNext.before(buttonPrev);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Carousel), {
      value: _unref(bannersForShow),
      numVisible: 1,
      numScroll: 1,
      circular: "",
      "autoplay-interval": 30000,
      "show-navigators": !_unref(state).layout.isMobile && _unref(bannersForShow).length > 1,
      "show-indicators": _unref(bannersForShow).length > 1,
      pt: {
        previousButton: { class: 'carousel-navigator left-0 ml-s2' },
        nextButton: { class: 'carousel-navigator right-0 mr-s2' },
      },
      class: "carousel-banner relative"
    }, {
      item: _withCtx((slotProps) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(slotProps.data.component())))
      ]),
      _: 1
    }, 8, ["value", "show-navigators", "show-indicators"])
  ]))
}
}

})